import React from "react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { fmtNum, MONTHS_IT } from "@/lib/constants";
import { formatCounterHours } from "@/lib/counterHours";

const rows = [
  ["Residuo anno precedente", "previous_residual"],
  ["Maturato fino al mese", "accrued_to_month"],
  ["Goduto nel mese", "consumed_month"],
  ["Goduto da gennaio", "consumed_ytd"],
  ["Rettifiche da gennaio", "adjustments_ytd"],
  ["Residuo aggiornato", "residual"],
];

export function RateiDetailGrid({ pool, testid = "ratei-detail" }) {
  const unit = pool?.unit === "days" ? "gg" : "h";
  if (!pool) {
    return <div className="py-5 text-sm text-suite-neutral-500">Nessun dato disponibile.</div>;
  }
  const visibleRows = rows.filter(([, key]) => key !== "adjustments_ytd" || Number(pool.adjustments_ytd || 0) !== 0);
  return (
    <div className="overflow-hidden rounded-lg border border-suite-neutral-200" data-testid={testid}>
      {visibleRows.map(([label, key], index) => (
        <div
          key={key}
          className={`flex items-center justify-between gap-4 px-4 py-3 ${index ? "border-t border-suite-neutral-100" : ""} ${key === "residual" ? "bg-suite-primary/5" : "bg-white"}`}
        >
          <span className={`text-sm ${key === "residual" ? "font-semibold text-suite-neutral-800" : "text-suite-neutral-600"}`}>{label}</span>
          <span className={`font-mono tabular-nums ${key === "residual" ? "text-lg font-bold text-suite-primary" : "text-sm font-semibold text-suite-neutral-800"}`}>
            {pool?.precision === 6 ? formatCounterHours(pool[key] || 0) : fmtNum(pool[key] || 0)} {unit}
          </span>
        </div>
      ))}
    </div>
  );
}

export function CounterSourceBadge({ consolidation }) {
  if (!consolidation?.enabled) return null;
  const anchor = consolidation.anchor;
  const period = anchor ? `${MONTHS_IT[anchor.month - 1]} ${anchor.year}` : "";
  const labels = {
    consolidated: ["Consolidato alla chiusura", `fotografia v.${anchor?.snapshot_version} di ${period}`, "bg-emerald-50 text-emerald-800 border-emerald-200"],
    baseline: ["BASELINE RICOSTRUITA – NON ORIGINALE", `approvata, mese di riferimento ${period}`, "bg-amber-50 text-amber-900 border-amber-300"],
    anchored: ["Valore corrente (non consolidato)", `parte ${anchor?.kind === "baseline" ? "dalla baseline ricostruita" : "dal saldo consolidato"} di ${period}`, "bg-sky-50 text-sky-800 border-sky-200"],
    recalculated: ["Ricalcolato (non consolidato)", "nessuna fotografia di chiusura disponibile", "bg-suite-neutral-50 text-suite-neutral-700 border-suite-neutral-200"],
  };
  const [title, detail, tone] = labels[consolidation.source] || labels.recalculated;
  return (
    <div className={`inline-flex items-center gap-2 rounded-md border px-2.5 py-1 text-xs ${tone}`} data-testid="counter-source-badge" data-source={consolidation.source}>
      <span className="font-semibold">{title}</span><span>· {detail}</span>
    </div>
  );
}

export function RateiDetailDialog({ open, onOpenChange, pool, label }) {
  const monthLabel = pool?.month ? MONTHS_IT[pool.month - 1] : "";
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-md" data-testid="ratei-detail-dialog">
        <DialogHeader>
          <DialogTitle>{label}</DialogTitle>
          <DialogDescription>
            Situazione al {monthLabel} {pool?.year || ""}. Dati in sola lettura.
          </DialogDescription>
        </DialogHeader>
        <RateiDetailGrid pool={pool} />
      </DialogContent>
    </Dialog>
  );
}
